import { css } from '@emotion/css';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../features';
import { PageConfirmBlock } from './PageConfirmBlock';
import { ReportMenu } from './ReportMenu';

export const PageFriendDetailMenu: React.FC = () => {
  const { id, page } = useParams<{ id?: string; page?: string }>();
  const { friendItems, profiles, profileErrorType } = useSelector(
    (state: RootState) => state.bestFriends
  );
  const friendItem = friendItems.find(item => item.id === id);
  const profile = profiles.find(item => item.userId === id);
  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #f5f1e3;
      `}
    >
      {(() => {
        switch (page) {
          case '1':
            return (
              friendItem && (
                <ReportMenu
                  friendItem={friendItem}
                  profile={profile}
                  profileErrorType={profileErrorType}
                />
              )
            );
          case '2':
            return friendItem && <PageConfirmBlock friendItem={friendItem} />;
          default:
            return <></>;
        }
      })()}
    </div>
  );
};
